import Ingress from './Ingress';
import * as actions from './actions';
import * as selectors from './selectors';
import reducer from './reducers';
import * as types from './types';
import sagas from './sagas';

export default Ingress;
export { actions, reducer, selectors, types, sagas };
